import React, { FC } from 'react';
import '../../App.scss';
import { useTranslation } from 'react-i18next';
import { colorMap, Colors, Sizes } from '../../constants/colorMap';
import { clsx } from 'clsx';

import styles from './styles.module.scss';
import DiamondButton from '../DiamondButton';
// import pattern from '../../assets/pattern.svg';
import PlayButton from '../PlayButton';
import Button from '../Button';
import { ProductTypes } from '../../types/enums';

interface IBlockProps {
  text: string;
  description?: string;
  buttonText?: string;
  variant?: 'primary' | 'primary-color' | 'secondary' | 'tertiary';
  buttonAction: (
    e: React.MouseEvent<HTMLButtonElement>,
  ) => void | Promise<void> | object;
  image?: any;
  type?: `${ProductTypes}`;
  customBackground?: string;
  color?: Colors;
  size?: Sizes;
  main?: boolean;
  isLongText?: boolean;
}

const Block: FC<IBlockProps> = ({
  text,
  description,
  buttonAction,
  buttonText,
  color = 'pink',
  size = 'medium',
  type,
  customBackground,
  image,
  main,
  isLongText,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={clsx(styles.block, styles[`block_${main ? 'main' : size}`])}
    >
      <div
        className={clsx(
          styles.container,
          styles[main ? 'main' : size],
          type && styles[type],
        )}
        style={{
          ...(color && { background: `${colorMap[color]}1)` }),
          ...(customBackground && {
            backgroundImage: customBackground,
          }),
        }}
      >
        {main ? <PlayButton onClick={buttonAction} /> : <></>}
        <h3 className={clsx(styles.text, isLongText && styles.longText)}>
          {t(text)}
        </h3>
        {description && <p className={styles.description}>{t(description)}</p>}
        {buttonText && !type ? (
          <Button text={t(buttonText)} onClick={buttonAction} />
        ) : !main ? (
          <DiamondButton
            color={color}
            onClick={buttonAction}
            text={t(buttonText ? buttonText : 'Select')}
          />
        ) : (
          <></>
        )}
      </div>

      {image && <img src={image} className={styles.image} alt="block image" />}
    </div>
  );
};

export default Block;
